module.exports = __webpack_public_path__ + "static/media/icon_3_1.19385cc1.svg";